// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"9273aede","528":"d38e8dd0","562":"cb27102e","666":"469a8eaa","941":"d04ee9aa"}[chunkId] + ".css";
};